import { css } from '@emotion/react';
import { mediaQuery } from '../helpers';
import { theme } from '../theme';
import { tokens } from '../tokens';
import { popoverEnter, popoverExit } from './keyframes';
const ANIMATION_DISTANCE = '12px';
const placementAnimationDirectionMap = {
    bottom: `0, -${ANIMATION_DISTANCE}`,
    bottomLeft: `0, -${ANIMATION_DISTANCE}`,
    bottomRight: `0, -${ANIMATION_DISTANCE}`,
    left: `${ANIMATION_DISTANCE}, 0`,
    right: `-${ANIMATION_DISTANCE}, 0`,
    top: `0, ${ANIMATION_DISTANCE}`,
    topLeft: `0, ${ANIMATION_DISTANCE}`,
    topRight: `0, ${ANIMATION_DISTANCE}`,
};
const wrapperStaticStyle = css({
    border: `${tokens.borderWidth.thin} solid ${theme.border.main}`,
    maxHeight: '500px',
    [mediaQuery.aboveSmall]: {
        minHeight: 'unset',
        minWidth: '300px',
    },
});
export function wrapperStyle({ isOpen, placement }) {
    const animationDirection = placementAnimationDirectionMap[placement];
    return [
        wrapperStaticStyle,
        css({
            // Animation from direction based on placement
            animation: `${isOpen ? popoverEnter({ animationDirection }) : popoverExit}
      200ms cubic-bezier(0.2, 0.8, 0.6, 1) forwards`,
            transform: `translate(${animationDirection})`,
        }),
    ];
}
export const cardStaticStyle = css({
    '&:focus-within': {
        boxShadow: 'none',
        transform: 'translateY(0)',
    },
    border: 0,
    borderRadius: tokens.borderRadius.medium,
    display: 'flex',
    flexDirection: 'column',
    lineHeight: tokens.lineHeights.default,
    maxHeight: '500px',
    maxWidth: '600px',
    minWidth: '300px',
    padding: 0,
});
export const headerStaticStyle = css({
    flexShrink: 0,
    padding: `${tokens.spacing.medium} 48px ${tokens.spacing.medium} ${tokens.spacing.medium}`,
});
export const closeButtonStaticStyle = css({
    color: theme.text.main,
    position: 'absolute',
    right: '6px',
    top: '6px',
    zIndex: tokens.zIndex.default,
});
export const bodyWrapperStaticStyle = css({
    paddingBottom: 0,
});
export const bodyStaticStyle = css({
    marginBottom: 0,
});
export const countStaticStyle = css({
    color: theme.text.subtle,
    display: 'flex',
    flexGrow: 1,
    userSelect: 'none',
});
